"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StorageAPI =
/*#__PURE__*/
function () {
  function StorageAPI(storage, storageKey, initialState) {
    _classCallCheck(this, StorageAPI);

    this.storage = storage;
    this.storageKey = storageKey;

    if (!!initialState) {
      this.setState(initialState);
    }
  }

  _createClass(StorageAPI, [{
    key: "getState",
    value: function getState() {
      var auth = JSON.parse(this.storage.getItem(this.storageKey) || '{}');
      return auth || {};
    }
  }, {
    key: "setState",
    value: function setState(newState) {
      var currentState = this.getState();
      var mergedState = Object.assign({}, currentState, newState);
      this.storage.setItem(this.storageKey, JSON.stringify(mergedState));
    }
  }, {
    key: "purgeState",
    value: function purgeState() {
      this.storage.removeItem(this.storageKey);
    }
  }]);

  return StorageAPI;
}();

exports.StorageAPI = StorageAPI;